function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as types from './types';
export var initialState = {
  hasPermission: false,
  token: undefined
};
export default function messaging(state, _ref) {
  if (state === void 0) {
    state = initialState;
  }

  var payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case types.PERMISSION_CHANGED:
    case types.TOKEN_CHANGED:
    case types.MESSAGING_ERROR:
    case types.ON_MESSAGE:
      return _extends({}, state, payload);

    case types.ON_CLEAR_MESSAGE:
      var _state = state,
          message = _state.message,
          rest = _objectWithoutPropertiesLoose(_state, ["message"]);

      return _extends({}, rest);

    default:
      return state;
  }
}